import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div<{ backgroundColor?: string }>(props => ({
    display: "inline-flex",
    flexDirection: "column",
    justifyContent: "stretch",
    padding: "4px 0",
    marginTop: -4,
    width: "100%",
    backgroundColor: props.backgroundColor ?? theme(props).keyPalette.panelBackgroundColor,
}));
